export default {
    getItem: function (sKey: string) {
        const val = document.cookie.replace(
            new RegExp(
                '(?:(?:^|.*;)\\s*' + sKey.replace(/[-.+*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$'
            ),
            '$1'
        );
        try {
            return decodeURIComponent(val) || null;
        } catch (e) {
            return val || null;
        }
    },

    setItem: function ({
        sKey,
        sValue,
        vEnd,
        sDomain = '',
        sPath = '/',
        bSecure = false,
        sameSite = 'lax'
    }: {
        sKey: string;
        sValue: string;
        vEnd?: string | number;
        sDomain?: string;
        sPath?: string;
        bSecure?: boolean;
        sameSite?: string;
    }) {
        if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
            return false;
        }
        let sExpires = '';
        if (vEnd) {
            switch (vEnd.constructor) {
                case Number:
                    sExpires =
                        vEnd === Infinity
                            ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT'
                            : '; max-age=' + vEnd;
                    break;
                case String:
                    sExpires = '; expires=' + vEnd;
                    break;
                case Date:
                    sExpires = '; expires=' + (vEnd as unknown as Date).toUTCString();
                    break;
            }
        }
        document.cookie =
            sKey +
            '=' +
            sValue +
            sExpires +
            (sDomain ? '; domain=' + sDomain : '') +
            (sPath ? '; path=' + sPath : '') +
            `; samesite=${sameSite} ` +
            (bSecure ? '; secure' : '');
        return true;
    },

    removeItem: function (sKey: string, sDomain?: string, sPath: string = '/') {
        if (!sKey || !this.hasItem(sKey)) {
            return false;
        }
        document.cookie =
            sKey +
            '=; expires=Thu, 01 Jan 1970 00:00:00 GMT' +
            (sDomain ? '; domain=' + sDomain : '') +
            (sPath ? '; path=' + sPath : '');
        return true;
    },

    hasItem: function (sKey: string) {
        return new RegExp('(?:^|;\\s*)' + sKey.replace(/[-.+*]/g, '\\$&') + '\\s*\\=').test(
            document.cookie
        );
    },

    keys: function () {
        var aKeys = document.cookie
            .replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, '')
            .split(/\s*(?:\=[^;]*)?;\s*/);
        for (var nIdx = 0; nIdx < aKeys.length; nIdx++) {
            aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]);
        }
        return aKeys;
    },

    clearCookies: function (sDomain?: string, sPath?: string) {
        var cookies = document.cookie.split(';');
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            var eqPos = cookie.indexOf('=');
            var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            this.removeItem(name, sDomain, sPath);
        }
    }
};
